<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
            
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="https://www.koomkah.com">
                        <img src="img/brand/white.png" style="width: auto;">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-user-run d-lg-none"></i>
                        <span class="nav-link-inner--text">สมาชิก</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <a href="https://member.koomkah.com"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-user-run"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">สมาชิก</h6>
                                <p class="description d-none d-md-inline-block mb-0">เข้าสู่ระบบสมาชิก</p>
                            </div>
                        </a>
                    </div>
                </base-dropdown>
            </ul>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">ธนาคาร</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <a href="https://bank.koomkah.com"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-world"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">พนักงานธนาคาร</h6>
                                <p class="description d-none d-md-inline-block mb-0">เข้าสู่ระบบรับซื้อหน้างาน</p>
                            </div>
                        </a>
                        <a href="https://admin.koomkah.com"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-shop"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">ผู้จัดการธนาคาร</h5>
                                <p class="description d-none d-md-inline-block mb-0">เข้าสู่ระบบจัดการธนาคาร</p>
                            </div>
                        </a>
                    </div>
                </base-dropdown>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://web.facebook.com/koomkah" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Like us on Facebook">
                        <i class="fa fa-facebook-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Facebook</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="http://nav.cx/oZdsD5"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="line channel">
                        <i class="fa fa-user-o"></i>
                        <span class="nav-link-inner--text d-lg-none">Line</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
